import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useLocalizeMessage, Link, useDateTimeFormat, LocaleContext, formatStudyString } from 'libs.nucleus';
import { OrgContext } from '../../contexts/org';
import { getParticipantNextVisitWindow, getParticipantNumber, getParticipantStatus, } from '../../helpers/participants.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
export const useParticipantsTableColumns = () => {
    const translate = useLocalizeMessage();
    const { environment } = useCurrentEnvironment();
    const { formatDateTime, formatPlainDate } = useDateTimeFormat();
    const { participantStatusMap } = useContext(OrgContext);
    const currentLocale = useContext(LocaleContext);
    const participantsColumns = useMemo(() => {
        return [
            {
                header: translate('label.participant.number'),
                accessorKey: 'c_number',
                cell: (context) => {
                    const row = context.row.original;
                    return (_jsx(Link, { LinkComponent: RouterLink, to: `/site/study/${environment?.id}/participants/${row._id}`, children: getParticipantNumber(row) }));
                },
            },
            {
                header: translate('generic.create', { tense: 'past' }),
                accessorKey: 'created',
                cell: (context) => formatDateTime(context.getValue()),
            },
            {
                header: translate('label.participants_table.next_visit_window'),
                accessorKey: 'c_visit_schedule',
                cell: (context) => {
                    return getParticipantNextVisitWindow(context.row.original, formatPlainDate, translate);
                },
            },
            {
                header: translate('generic.status'),
                accessorKey: 'c_status',
                cell: (context) => {
                    const status = context.getValue();
                    const statusLabel = participantStatusMap.get(status) || status;
                    return getParticipantStatus(formatStudyString(statusLabel, currentLocale));
                },
            },
        ];
    }, [currentLocale, environment?.id, formatDateTime, formatPlainDate, participantStatusMap, translate]);
    return {
        participantsColumns,
    };
};
